import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import PropTypes from 'prop-types';
import styles, { colors } from '../../style/rulesEngine';
import { STARTER_EXAMPLES } from './cascadeConfig';

const EmptyState = ({ onCreateFirst, onStarterSelected }) => {
  return (
    <View style={styles.emptyState}>
      <AntDesign name="filter" size={48} color={colors.textMuted} style={{ marginBottom: 12 }} />
      <Text style={styles.emptyStateTitle}>Automate your order processing</Text>
      <Text style={styles.emptyStateSubtext}>
        Rules run automatically when orders arrive -- no manual checking needed.
      </Text>
      <TouchableOpacity onPress={onCreateFirst} style={styles.emptyStateCTA}>
        <Text style={styles.emptyStateCTAText}>+ Create Your First Rule</Text>
      </TouchableOpacity>

      {STARTER_EXAMPLES.map((example) => (
        <TouchableOpacity
          key={example.title}
          onPress={() => onStarterSelected(example)}
          style={styles.starterCard}
        >
          <Text style={styles.starterCardTitle}>{example.title}</Text>
          <Text style={styles.starterCardDesc}>{example.description}</Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

EmptyState.propTypes = {
  onCreateFirst: PropTypes.func.isRequired,
  onStarterSelected: PropTypes.func.isRequired,
};

export default EmptyState;
